var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 5.49316C13.5304 5.49316 14.0391 5.70388 14.4142 6.07895C14.7893 6.45402 15 6.96273 15 7.49316M13 1.49316C14.5913 1.49316 16.1174 2.12531 17.2426 3.25052C18.3679 4.37574 19 5.90187 19 7.49316M3 2.49316H7L9 7.49316L6.5 8.99316C7.57096 11.1647 9.32847 12.9222 11.5 13.9932L13 11.4932L18 13.4932V17.4932C18 18.0236 17.7893 18.5323 17.4142 18.9074C17.0391 19.2824 16.5304 19.4932 16 19.4932C12.0993 19.2561 8.42015 17.5997 5.65683 14.8363C2.8935 12.073 1.23705 8.3939 1 4.49316C1 3.96273 1.21071 3.45402 1.58579 3.07895C1.96086 2.70388 2.46957 2.49316 3 2.49316Z",
    stroke: "#09052F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.e5afb86cf786a4b8447f234072540b00.svg";
export { ForwardRef as ReactComponent };